import moment, { isMoment } from 'moment';
import React, { Component } from 'react';
import { Button, ControlLabel, FormControl, FormGroup, Modal } from 'react-bootstrap';
import DateTime from 'react-datetime';
import { connect } from 'react-redux';

import { DATE_FORMAT } from '../common/dateTimeFormats';
import OverlayLoader from '../components/overlayLoader';
import { showModalMessage } from '../store/modalsSlice';

import * as productReleasesActions from '../store/productReleasesSlice';
import { productReleasesSelectors } from '../store/productReleasesSlice';

import { normalizeVersionNumberInput } from '../common/normalizeKeyInput';
import { unwrapResult } from '@reduxjs/toolkit';

const Mode = {
  Create: 0,
  Edit: 1
};

const Titles = {
  [Mode.Create]: "Create new product release",
  [Mode.Edit]: "Edit product release"
};

const SubmitButtonCaptions = {
  [Mode.Create]: "Create",
  [Mode.Edit]: "Save"
};

class ProductReleaseEditDialog extends Component {
  initState = {
    product: null,
    version: null,
    releaseDate: moment().format(DATE_FORMAT)
  };

  constructor(props) {
    super(props);
    this.handleClose = this.props.onClose;

    this.state = this.initState;

    this.onShow = this.onShow.bind(this);
    this.onClose = this.onClose.bind(this);

    this.onProductChanged = this.onProductChanged.bind(this);
    this.onVersionChanged = this.onVersionChanged.bind(this);
    this.onReleaseDateChanged = this.onReleaseDateChanged.bind(this);

    this.onSubmit = this.onSubmit.bind(this);
  }

  static get Mode() {
    return Mode;
  }

  onShow() {
    this.setState(this.initState);
    if (this.props.products !== undefined && this.props.products.length > 0)
      this.setState({ product: this.props.products[0] });
    if (this.props.mode === Mode.Edit) {
      if (this.props.product !== undefined) {
        this.setState({ product: this.props.product });
      }
      if (this.props.version !== undefined) {
        this.setState({ version: this.props.version });
      }
      if (this.props.releaseDate !== undefined) {
        this.setState({ releaseDate: this.props.releaseDate });
      }
    }
  }

  onClose() {
    this.handleClose();
    this.setState(this.initState);
  }

  onProductChanged(e) {
    this.setState({ product: e.target.value });
  }

  onVersionChanged(e) {
    const normalizedValue = normalizeVersionNumberInput(e.target.value);
    if (normalizedValue === null) return;
    this.setState({ version: normalizedValue || null });
  }

  onReleaseDateChanged(value) {
    let releaseDate = null;
    if (isMoment(value) && value.isValid())
      releaseDate = value.format(DATE_FORMAT);
    this.setState({ releaseDate });
  }

  isLodaing() {
    return this.props.isProductReleaseCreating ||
      this.props.isProductReleaseUpdating;
  }

  getLoaderMessage() {
    if (this.props.isProductReleaseCreating) {
      return "Product release adding...";
    }
    if (this.props.isProductReleaseUpdating) {
      return "Product release updating...";
    }
  }

  isSubmitButtonDisabled() {
    return this.isLodaing() ||
      this.state.product === null ||
      this.state.version === null ||
      this.state.releaseDate === null ||
      (this.props.mode === Mode.Edit &&
        this.state.product === this.props.product &&
        this.state.version === this.props.version &&
        this.state.releaseDate === this.props.releaseDate);
  }

  onSubmit() {
    this.onClose();
    let submitPromise;
    const { product, version, releaseDate } = this.state;
    const { id } = this.props;

    switch (this.props.mode) {
      case Mode.Create:
        submitPromise = this.props.addProductRelease({
          productName: product, productVersion: version, releaseDate
        });
        break;
      case Mode.Edit:
        submitPromise = this.props.updateProductRelease({
          id, productName: product, productVersion: version, releaseDate
        });
        break;
      default:
        submitPromise = null;
    }

    if (submitPromise == null) {
      this.props.showModalMessage("Error", "Unknown dialog mode");
      return;
    }

    submitPromise
      .then(unwrapResult)
      .catch(() => {
        this.props.showModalMessage("Error", this.props.onSubmitError.toString());
      });
  }

  render() {
    return (
      <Modal bsSize="small" show={this.props.show} onShow={this.onShow} onHide={this.onClose} backdrop="static">
        <Modal.Header>
          <Modal.Title>{Titles[this.props.mode]}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <OverlayLoader active={this.isLodaing()} text={this.getLoaderMessage()}>
            <FormGroup controlId="fcProdName">
              <ControlLabel>Product name</ControlLabel>
              <FormControl
                componentClass="select"
                placeholder="Product name"
                value={this.state.product}
                onChange={this.onProductChanged}
              >
                {this.props.products.map(product => {
                  return (
                    <option key={product} value={product}>{product}</option>
                  );
                })}
              </FormControl>
            </FormGroup>
            <FormGroup controlId="fcVersion">
              <ControlLabel>Version</ControlLabel>
              <FormControl value={this.state.version} onChange={this.onVersionChanged} type="text" />
            </FormGroup>
            <FormGroup controlId="fcReleaseDate">
              <ControlLabel>Release date</ControlLabel>
              <DateTime
                value={this.state.releaseDate}
                dateFormat={DATE_FORMAT}
                timeFormat={false}
                closeOnSelect={true}
                onChange={val => this.onReleaseDateChanged(val)}
              />
            </FormGroup>
          </OverlayLoader>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.onSubmit} disabled={this.isSubmitButtonDisabled()}>
            {SubmitButtonCaptions[this.props.mode]}
          </Button>
          <Button onClick={this.onClose}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  isProductReleaseCreating: productReleasesSelectors.isCreating(state),
  isProductReleaseUpdating: productReleasesSelectors.isUpdating(state),
  onSubmitError: productReleasesSelectors.creatingUpdatingError(state),
});

const actionCreators = {
  addProductRelease: productReleasesActions.create,
  updateProductRelease: productReleasesActions.update,
  showModalMessage: (title, text) => showModalMessage({ title, text }),
};

export default connect(mapStateToProps, actionCreators)(ProductReleaseEditDialog);



// WEBPACK FOOTER //
// ./src/containers/productReleaseEditDialog.js